import { Component, Input, forwardRef, Output, EventEmitter, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgbTypeahead, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

import { SelectListItemViewModel } from './../../business-entities/select-list-item-view-model';

@Component({
    selector: 'app-dealer-searchbox',
    styleUrls: ['./dealer-searchbox.component.css'],
    templateUrl: 'dealer-searchbox.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => DealerSearchboxComponent)
        }
    ]
})
export class DealerSearchboxComponent implements ControlValueAccessor {
    @Input() dealerList: SelectListItemViewModel[];
    @Input() classes: string = '';
    @Output() onSelectDealer = new EventEmitter<string>();
    selectedDealerId: string;
    dealerSelected: any;
    input: any;
    disabled: boolean = false;

    @ViewChild('typeaheadInstance')
    private typeaheadInstance: NgbTypeahead;

    formatter = (result: SelectListItemViewModel) => {
        return result.text.toUpperCase();
    }

    search = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map(term => {
                return term === '' ? []
                    : this.dealerList.filter(v => v.text.toLowerCase().indexOf(term.toLowerCase()) > -1)
            })
        )

    setDealer(event: NgbTypeaheadSelectItemEvent) {
        event.preventDefault();
        this.selectedDealerId = event.item.value;
        this.dealerSelected = event.item.text;
        this.writeValue(this.dealerSelected);
        this.onSelectDealer.emit(this.selectedDealerId);
    }

    writeValue(value: any) {
        this.input = value;
    }

    registerOnChange(fn: (value: any) => void) {
        this.onChange = fn;
    }

    onChange(_value: any) {
       // This is intentional
     }

    registerOnTouched(fn: (value: any) => void) {
        this.onTouched = fn;
    }

    onTouched(_value: any) {
      // This is intentional
    }

    setDisabledState(disabled: boolean) {
        this.disabled = disabled;
    }

    typeaheadKeydown(_$event: KeyboardEvent) {
        if (this.typeaheadInstance.isPopupOpen()) {
          setTimeout(() => {
            const popup = document.getElementById(this.typeaheadInstance.popupId);
            const activeElements = popup.getElementsByClassName('active');
            if (activeElements.length === 1) {

              const elem = (activeElements[0] as any);
              if (typeof elem.scrollIntoViewIfNeeded === 'function') {
                // non standard function, but works (in chrome)...
                elem.scrollIntoViewIfNeeded();
              } else {
                //do custom scroll calculation or use jQuery Plugin or ...
                this.scrollIntoViewIfNeededPolyfill(elem as HTMLElement);
              }
            }
          });
        }
      }

      private scrollIntoViewIfNeededPolyfill(elem: HTMLElement, centerIfNeeded = true) {
        let parent = elem.parentElement,
          parentComputedStyle = window.getComputedStyle(parent, null),
          parentBorderTopWidth = parseInt(parentComputedStyle.getPropertyValue('border-top-width')),
          parentBorderLeftWidth = parseInt(parentComputedStyle.getPropertyValue('border-left-width')),
          overTop = elem.offsetTop - parent.offsetTop < parent.scrollTop,
          overBottom = (elem.offsetTop - parent.offsetTop + elem.clientHeight - parentBorderTopWidth) > (parent.scrollTop + parent.clientHeight),
          overLeft = elem.offsetLeft - parent.offsetLeft < parent.scrollLeft,
          overRight = (elem.offsetLeft - parent.offsetLeft + elem.clientWidth - parentBorderLeftWidth) > (parent.scrollLeft + parent.clientWidth),
          alignWithTop = overTop && !overBottom;

        if ((overTop || overBottom) && centerIfNeeded) {
          parent.scrollTop = elem.offsetTop - parent.offsetTop - parent.clientHeight / 2 - parentBorderTopWidth + elem.clientHeight / 2;
        }

        if ((overLeft || overRight) && centerIfNeeded) {
          parent.scrollLeft = elem.offsetLeft - parent.offsetLeft - parent.clientWidth / 2 - parentBorderLeftWidth + elem.clientWidth / 2;
        }

        if ((overTop || overBottom || overLeft || overRight) && !centerIfNeeded) {
          elem.scrollIntoView(alignWithTop);
        }
      }
}
